"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelMergeCart = cancelMergeCart;
exports.cancelOrder = cancelOrder;
exports.createReturnItem = createReturnItem;
exports.downloadInvoice = downloadInvoice;
exports.getInStoreOrder = void 0;
exports.getInStoreOrderDetails = getInStoreOrderDetails;
exports.getMyOrderJson = getMyOrderJson;
exports.getOrderDetails = getOrderDetails;
exports.getOrdersByShipment = getOrdersByShipment;
exports.getPackageTrackingInfo = getPackageTrackingInfo;
exports.getPrescriptionOrderDetails = void 0;
exports.getReturnDetails = getReturnDetails;
exports.getReturnStatus = getReturnStatus;
exports.mergeCart = mergeCart;
exports.newMergeCart = newMergeCart;
exports.reorder = reorder;
exports.returnItem = returnItem;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function getMyOrderJson(params, tokenData) {
  const {
    userId = '',
    ...rest
  } = params || {};
  const querystring = (0, _utils.getQuery)(rest);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.MY_ORDER_LIST + querystring;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getOrderDetails(params, tokenData) {
  const {
    orderId,
    userId = '',
    ...rest
  } = params || {};
  const querystring = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.ORDER_DETAILS_URL)(orderId)}${querystring}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function cancelOrder(data, tokenData) {
  const {
    userId = '',
    ...rest
  } = data || {};
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.CANCEL_ORDER_URL;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = rest;
  options.method = _ApiConst.API_PARAMS.POST;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: data, requestType: API_PARAMS.POST });
}
function returnItem(body, tokenData) {
  const {
    userId = '',
    ...rest
  } = body || {};
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.RETURN_ORDER}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = rest;
  options.method = _ApiConst.API_PARAMS.POST;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: body, requestType: API_PARAMS.POST });
}
function getPackageTrackingInfo(params, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PACKAGE_TRACKING_URL;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: params });
}
function downloadInvoice(orderId, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.DOWNLOAD_INVOICE)(orderId)}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function mergeCart(params, tokenData) {
  const querystring = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.MERGE_CART + querystring;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function newMergeCart(params, tokenData) {
  const querystring = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.NEW_MERGE_CART + querystring;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function cancelMergeCart(params, tokenData) {
  const querystring = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.CANCEL_MERGE_CART + querystring;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function reorder(body, tokenData) {
  const {
    page,
    userId = '',
    ...rest
  } = body || {};
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.REORDER + `?page=${page}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = rest;
  options.method = _ApiConst.API_PARAMS.POST;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: body, requestType: API_PARAMS.POST });
}
const getInStoreOrder = (params, tokenData) => {
  const querystring = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.INSTORE_ORDERS_API + querystring;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getInStoreOrder = getInStoreOrder;
function getInStoreOrderDetails(orderId, tokenData) {
  const apiEndPoint = _ApiConst.INSTORE_ORDERS_API + `/${orderId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getOrdersByShipment(tokenData) {
  const apiEndPoint = _ApiConst.GET_ORDERS_BY_SHIPMENT;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
const getPrescriptionOrderDetails = (params, tokenData) => {
  // const querystring = getQuery(params);
  const apiEndPoint = _ApiConst.INSTORE_ORDER_BASE_URL + '/v1' + `/${params}` + '/details';
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getPrescriptionOrderDetails = getPrescriptionOrderDetails;
function createReturnItem(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CREATE_RETURN}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getReturnStatus(params, tokenData) {
  const querystring = (0, _utils.getQuery)(params);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_RETURN_STATUS}${querystring}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getReturnDetails(params, tokenData) {
  const {
    reqId = '',
    consignmentId = '',
    ...rest
  } = params || {};
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.GET_RETURN_DETAILS)(reqId, consignmentId)}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = rest;
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}